export default "__VITE_ASSET__f01eca64__"